export default "__VITE_ASSET__4ae92a1a__"